import React, { forwardRef, useMemo } from 'react';
import { FieldTypes, urlRegexValidator } from 'utils/formUtils';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import SpectralMappingForm from './SpectralMappingForm';

const SpectralCredentialsForm = forwardRef((props, ref) => {
    const fields = useMemo(() => [{
            name: "apiEndpoint",
            label: "API Endpoint",
            rules:[urlRegexValidator]
        },
        {
            name: "apiToken",
            label: "Token",
            required: true,
            type: FieldTypes.PASSWORD,
        }
    ], []);
    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            MappingForm={SpectralMappingForm}
            initialValue={{ apiEndpoint: "https://app.spectralops.io/api/v1" }}
        />
    )
});

export default SpectralCredentialsForm;